import { __exports as e } from "../../../../../../../../../_virtual/inbox-composer.js";
import { __require as _ } from "./default.js";
var r;
function i() {
  if (r) return e;
  r = 1, Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.INBOX_COMPOSER_CONFIG = void 0;
  var O = _(), o = Object.assign({}, O.DEFAULT_CONFIG, {
    ALLOW_UNKNOWN_PROTOCOLS: !0
  });
  return e.INBOX_COMPOSER_CONFIG = o, e;
}
export {
  i as __require
};
